import React, { useEffect } from "react";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import "./style.scss";
import BuildingBlueSquare from "../../../icons/BuildingBlueSquare";
import GreenTimerSquare from "../../../icons/GreenTimerSquare";
import MileagePurpleSquare from "../../../icons/MileagePurpleSquare";
import GraphOrangeSquare from "../../../icons/GraphOrangeSquare";
import { useDispatch, useSelector } from "react-redux";
import { getSpouseDashoard } from "../../../core/data/redux/dashboard/_dashboardAction";
import AssignedPropertiesDashboardList from "../../../core/components/common/assignedPropertiesDashboardList";
import { formatDate, logHourFormatTime } from "../../../constants/date";

const SpouseDashboard = () => {
  const { isSidebarOpen } = useOutletContext<{
    isSidebarOpen: boolean;
    onToggleSidebar: () => void;
  }>();
  const dispatch: any = useDispatch();

  const spouseDashboardState = useSelector((state: any) => state?.dashboard);
  const dashboardData = spouseDashboardState?.spouseDashoard;

  useEffect(() => {
    fertchDashboardData();
  }, [dispatch]);

  const fertchDashboardData = async () => {
    await dispatch(getSpouseDashoard({}));
  };

  return (
    <div className="layout">
      <Sidebar isOpen={isSidebarOpen} />

      <main className="content">
        <div className="profileSettings spousePages">
          <div className="d-flex justify-content-between align-items-center gap-3">
            <h2>Spouse Dashboard</h2>
          </div>

          <div className="fourBlocks">
            <div className="row align-items-stretch">
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 d-flex mb-3">
                <div className="blockWrapper w-100 d-flex align-items-center justify-content-between gap-2 flex-wrap">
                  <div className="d-flex flex-column gap-2">
                    <label>Assigned Properties</label>
                    <strong className="blueText">
                      {dashboardData?.total_assigned_properties || 0}
                    </strong>
                  </div>
                  <BuildingBlueSquare />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 d-flex mb-3">
                <div className="blockWrapper w-100 d-flex align-items-center justify-content-between gap-2 flex-wrap">
                  <div className="d-flex flex-column gap-2">
                    <label>Total Hours</label>
                    <strong className="greenText">
                      {dashboardData?.total_logged_hours || 0}
                    </strong>
                  </div>
                  <GreenTimerSquare />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 d-flex mb-3">
                <div className="blockWrapper w-100 d-flex align-items-center justify-content-between gap-2 flex-wrap">
                  <div className="d-flex flex-column gap-2">
                    <label>Total Mileage</label>
                    <strong className="purpleText">
                      {dashboardData?.total_mileage || 0}
                    </strong>
                  </div>
                  <MileagePurpleSquare />
                </div>
              </div>

              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 d-flex mb-3">
                <div className="blockWrapper w-100 d-flex align-items-center justify-content-between gap-2 flex-wrap">
                  <div className="d-flex flex-column gap-2">
                    <label>This Week</label>
                    <strong className="orangeText">
                      {dashboardData?.this_week_logged_hours || 0}{" "}
                    </strong>
                  </div>
                  <GraphOrangeSquare />
                </div>
              </div>
            </div>
          </div>

          <div className="assignedPropertiesBlock">
            <AssignedPropertiesDashboardList
              data={dashboardData?.assigned_properties}
            />
          </div>

          <div className="recentEntroesBlock">
            <h2 className="section-title">Recent Entries</h2>

            {dashboardData?.recent_entries?.length > 0 ? (

              dashboardData?.recent_entries?.map(
                (entry: any, index: number) => (
                  <ul>
                    <li className="d-flex justify-content-between gap-3 align-items-center">
                      <div className="d-flex gap-3 ">
                        {entry?.activity_type?.toLowerCase() === "hours" ? (
                          <GreenTimerSquare />
                        ) : (
                          <MileagePurpleSquare />
                        )}

                        <div className="d-flex flex-column gap-2">
                          <label>{entry?.property?.name}</label>
                          <p className="mb-0">
                            {entry?.activity_type?.toLowerCase() === "hours"
                              ? entry?.description
                              : entry?.purpose}
                          </p>
                          <p className="mb-0">Added On: {formatDate(entry?.date)}</p>
                        </div>
                      </div>

                      <div className="d-flex flex-column gap-1">
                        <span>
                          {entry?.activity_type?.toLowerCase() === "hours"
                            ? logHourFormatTime({
                              hours: entry?.hours,
                              minutes: entry?.minutes,
                            })
                            :
                            entry?.distance ? entry?.distance + " mi" : "0 mi"
                            //  logHourFormatTime({
                            //   hours: entry?.log_hour?.hours,
                            //   minutes: entry?.log_hour?.minutes,
                            // })
                          }
                        </span>
                        <label
                          className={
                            entry?.activity_type?.toLowerCase() === "hours"
                              ? "time-entry"
                              : "time-entry green"
                          }
                        >
                          {entry?.activity_type}
                        </label>
                      </div>
                    </li>
                  </ul>
                ))
            ) : (
              <p className="text-center text-muted py-4">No data available</p>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default SpouseDashboard;
